import { CommentId } from '../types'

// FixedCacheKeys are only applicable to mutations, while Queries use custom arg serializers.
export const getFixedCacheKey = {
  updateComment: (commentId: CommentId) => `updateComment(id${commentId})`,
  submitNewComment: (commentId: CommentId) => `submitNewComment(id${commentId})`
}
